import React, { Component } from "react";
import { Label, Grid, Table, Button, Input } from "semantic-ui-react";
// import { genexceldownload } from "../../services/fileanddownloads";
import moment from "moment";
import "../../containers/Reports.css";
import { queryserviceobject } from "../../services/crudservice";
import Roundy from "../../services/roundy";
import unpaidPdf from "../pdf/unpaidReportPDFDownload";
class matCharge extends Component {
  constructor() {
    super();
    this.state = {
      selected: [],
      startdate: moment()
        .startOf("isoWeek")
        .subtract(1, "weeks")
        .format("YYYY-MM-DD"),
      enddate: moment()
        .endOf("isoWeek")
        .subtract(1, "weeks")
        .format("YYYY-MM-DD"),
      reportdata: null
    };
  }
  componentDidMount() {
    this.getdata();
  }
  getdata() {
    queryserviceobject("reports", {
      report: "unused_hours",
      startdate: this.state.startdate,
      enddate: this.state.enddate
    }).then(reportdata => this.setState({ reportdata }));
  }
  gendatarows(mat_entries) {
    return mat_entries.map(temp_mat => {
      return (
        <Table.Row>
          <Table.Cell>{temp_mat.workordernumber}</Table.Cell>
          <Table.Cell>
            {moment(temp_mat.datepurchased).format("MM/DD/YYYY")}
          </Table.Cell>
          <Table.Cell>
            $ {Roundy(temp_mat.amount * temp_mat.markuppercent)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  genEmployees(reportdata) {
    return this.state.reportdata.map((d, i, a) => {
      return (
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan="3">
              <Label color="red" id="matname" ribbon>
                <h4>{d.empname}</h4>
              </Label>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell colSpan="3">
              <h3 id="unpaidtable">Days Unpaid</h3>
            </Table.HeaderCell>
          </Table.Row>
          {d.unpaid_days.map(ud => {
            return (
              <Table.Row>
                <Table.Cell>
                  <h5 id="unpaidtable">{ud}</h5>
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      );
    });
  }
  render() {
    var report = <h3>No Unpaid Days to report</h3>;

    if (this.state.reportdata) {
      if (this.state.reportdata.length) {
        report = <Table>{this.genEmployees()}</Table>;
      }
      return (
        <div>
          <Grid>
            <Grid.Column width={7}>
              <Grid.Row>
                <Input
                  label="Start Date"
                  type="date"
                  value={this.state.startdate}
                  onChange={e => {
                    this.setState(
                      {
                        startdate: moment(e.target.value).format("YYYY-MM-DD")
                      },
                      () => this.getdata()
                    );
                  }}
                />
                <Input
                  label="End Date"
                  type="date"
                  value={this.state.enddate}
                  onChange={e => {
                    this.setState(
                      {
                        enddate: moment(e.target.value).format("YYYY-MM-DD")
                      },
                      () => this.getdata()
                    );
                  }}
                />
                <Button
                  inverted
                  color="green"
                  onClick={() =>
                    unpaidPdf(
                      this.state.reportdata,
                      this.state.startdate,
                      this.state.enddate
                    )
                  }
                >
                  Print
                </Button>
              </Grid.Row>
              {report}
            </Grid.Column>
          </Grid>
        </div>
      );
    } else {
      return <h3>Loading .....</h3>;
    }
  }
}

export default matCharge;
{
  /* <Table.Row padded>
          <Table.HeaderCell colSpan="1">
            Material Charge Report
          </Table.HeaderCell>
          <Table.HeaderCell colSpan="1">
            <Button
              inverted
              color="blue"
              onClick={() => this.props.showFilterModal()}
            >
              Filter
            </Button>
          </Table.HeaderCell>
          <Table.HeaderCell colSpan="1">
            <Button
              inverted
              color="green"
              onClick={() => matpdfdownload(vendors, grand_total)}
            >
              Print
            </Button>
          </Table.HeaderCell>
        </Table.Row> */
}



// WEBPACK FOOTER //
// ./src/components/reports/unpaidDays.jsx